import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/dentlab/src/components/ui/button";

interface SidebarCollapseToggleProps {
	isCollapsed: boolean;
	onToggle: () => void;
	testId: string;
}

export const SidebarCollapseToggle: React.FC<SidebarCollapseToggleProps> = ({
	isCollapsed,
	onToggle,
	testId,
}) => {
	return (
		<div className="border-t flex items-center py-1 px-2">
			<Button
				variant="ghost"
				size="icon"
				onClick={onToggle}
				className="h-6 w-6"
				data-testid={testId}
				aria-label={isCollapsed ? "Panel erweitern" : "Panel zuklappen"}
			>
				{isCollapsed ? (
					<ChevronRight className="h-4 w-4 text-gray-500" />
				) : (
					<ChevronLeft className="h-4 w-4 text-gray-500" />
				)}
			</Button>
		</div>
	);
};
